var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPegmanMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.0737305,15.5244141C30.5673828,14.9550781,27.5151367,14,24,14s-6.5673828,0.9550781-8.0732422,1.5244141 C14.7744141,15.9589844,14,17.0849609,14,18.3261719V29c0,1.6542969,1.3457031,3,3,3h0.2192383l3.3256836,13.3017578 C20.9414062,46.890625,22.3623047,48,24,48s3.0585938-1.109375,3.4550781-2.6982422L30.7807617,32H31c1.6542969,0,3-1.3457031,3-3 V18.3261719C34,17.0849609,33.2255859,15.9589844,32.0737305,15.5244141z M32,29c0,0.5517578-0.4487305,1-1,1h-1 c-0.4589844,0-0.8588867,0.3125-0.9702148,0.7578125l-3.5151367,14.0595703C25.3408203,45.5136719,24.7177734,46,24,46 s-1.3408203-0.4863281-1.5146484-1.1826172l-3.5151367-14.0595703C18.8588867,30.3125,18.4589844,30,18,30h-1 c-0.5512695,0-1-0.4482422-1-1V18.3261719c0-0.4140625,0.2543945-0.7880859,0.6333008-0.9306641 C18.012207,16.8740234,20.8027344,16,24,16s5.987793,0.8740234,7.3671875,1.3955078 C31.7456055,17.5380859,32,17.9121094,32,18.3261719V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12c2.8530273,0,5-4.2460938,5-7c0-3.0371094-1.9624023-5-5-5s-5,1.9628906-5,5C19,7.7539062,21.1469727,12,24,12z  M24,2c1.9345703,0,3,1.0654297,3,3c0,2.1025391-1.7382812,5-3,5s-3-2.8974609-3-5C21,3.0654297,22.0654297,2,24,2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPegmanMedium);
export default __webpack_public_path__ + "static/media/pegman--medium.a3f6a571d8af3cc78d9071754a70a918.svg";
export { ForwardRef as ReactComponent };